// TODO: get this from @tesla/number-format package?
const formats = {
  fr: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: ' ',
  },

  AD: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: '.',
  },

  cs_CZ: {
    currency: 'CZK',
    decimal: ',',
    format: '%v %s',
    symbol: 'Kč',
    thousand: ' ',
  },

  en_AE: {
    currency: 'AED',
    decimal: '.',
    format: '%s %v',
    symbol: 'AED',
    thousand: ',',
  },

  en_AT: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: '.',
  },

  de_AT: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: '.',
  },

  en_AU: {
    currency: 'AUD',
    format: '%s%v',
    symbol: '$',
    symbol_foreign: 'AU$',
  },

  en_BE: {
    currency: 'EUR',
    decimal: ',',
    format: '%s %v',
    symbol: '\u20aC',
    thousand: '.',
  },

  fr_BE: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: '.',
  },

  nl_BE: {
    currency: 'EUR',
    decimal: ',',
    format: '%s %v',
    symbol: '\u20aC',
    thousand: '.',
  },

  en_CA: {
    currency: 'CAD',
    symbol: '$',
    symbol_foreign: 'CA$',
  },

  de_CH: {
    currency: 'CHF',
    decimal: ',',
    format: '%s %v',
    symbol: 'CHF',
    thousand: "'",
  },
  fr_CA: {
    currency: 'CAD',
    decimal: ',',
    format: '%v %s',
    symbol: '$',
    symbol_foreign: 'CA$',
    thousand: ' ',
  },
  fr_CH: {
    currency: 'CHF',
    decimal: ',',
    format: '%s %v',
    symbol: 'CHF',
    thousand: "'",
  },
  it_CH: {
    currency: 'CHF',
    decimal: ',',
    format: '%s %v',
    symbol: 'CHF',
    thousand: "'",
  },

  zh_CN: {
    currency: 'CNY',
    decimal: '.',
    format: '%s %v',
    symbol: '\u00A5',
    thousand: ',',
  },

  CY: {
    currency: 'EUR',
    decimal: ',',
    format: '%s %v',
    symbol: '\u20aC',
    thousand: '.',
  },

  de_DE: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: '.',
  },

  en_DK: {
    currency: 'DKK',
    decimal: ',',
    format: '%s %v',
    symbol: 'kr.',
    thousand: '.',
  },

  da_DK: {
    currency: 'DKK',
    decimal: ',',
    format: '%s %v',
    symbol: 'kr.',
    thousand: '.',
  },

  EE: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: '.',
  },

  es_ES: {
    currency: 'EUR',
    decimal: ',',
    format: '%s %v',
    symbol: '\u20aC',
    thousand: '.',
  },

  en_EU: {
    currency: 'EUR',
    decimal: ',',
    format: '%s %v',
    symbol: '\u20aC',
    thousand: '.',
  },

  fi_FI: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: '.',
  },

  fr_FR: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: ' ',
  },

  en_GB: {
    currency: 'GBP',
    symbol: '\u00A3',
  },

  GR: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: '.',
  },

  en_HK: {
    currency: 'HKD',
    symbol: 'HK$',
  },

  zh_HK: {
    currency: 'HKD',
    symbol: 'HK$',
  },

  IE: {
    currency: 'EUR',
    symbol: '\u20aC',
  },

  he_IL: {
    currency: 'ILS',
    decimal: '.',
    format: '%v %s',
    symbol: '₪',
    thousand: ',',
  },

  it_IT: {
    currency: 'EUR',
    decimal: ',',
    format: '%s %v',
    symbol: '\u20aC',
    thousand: '.',
  },

  ja_JP: {
    currency: 'JPY',
    symbol: '\u00A5',
  },

  fr_LU: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: ' ',
  },

  de_LU: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: ' ',
  },

  MC: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: ' ',
  },

  MT: {
    currency: 'MX',
    decimal: ',',
    symbol: '\u20aC',
    thousand: '.',
  },

  es_MX: {
    currency: 'MX',
    decimal: '.',
    symbol: '$',
    symbol_foreign: 'MX$',
    thousand: ',',
  },

  nl_NL: {
    currency: 'EUR',
    decimal: ',',
    format: '%s %v',
    symbol: '\u20aC',
    thousand: '.',
  },

  no_NO: {
    currency: 'NOK',
    decimal: ',',
    format: '%s %v',
    symbol: 'kr.',
    thousand: '.',
  },

  en_NZ: {
    currency: 'NZD',
    decimal: '.',
    symbol: '$',
    symbol_foreign: 'NZ$',
    thousand: ',',
  },

  sv_SE: {
    currency: 'SEK',
    decimal: ',',
    format: '%v %s',
    symbol: 'kr',
    thousand: ' ',
  },

  pt_PT: {
    currency: 'EUR',
    decimal: ',',
    format: '%v %s',
    symbol: '\u20aC',
    thousand: '.',
  },

  en_US: {
    currency: 'USD',
    decimal: '.',
    format: '%s%v',
    symbol: '$',
    thousand: ',',
  },

  en_ZA: {
    currency: 'ZAR',
    decimal: ',',
    symbol: 'R',
    thousand: '.',
  },

  en_IE: {
    currency: 'IRL',
    decimal: '.',
    format: '%s %v',
    symbol: '\u20aC',
    thousand: ',',
  },

  zh_MO: {
    currency: 'MAC',
    decimal: '.',
    symbol: 'HK$',
    thousand: ',',
  },

  en_MO: {
    currency: 'MAC',
    decimal: '.',
    position: 'prefix',
    symbol: 'HK$',
    thousand: ',',
  },

  zh_TW: {
    currency: 'TWN',
    decimal: '.',
    symbol: 'NT$',
    thousand: ',',
  },

  en_JO: {
    currency: 'JOD',
    decimal: '.',
    format: '%v %s',
    symbol: 'JOD',
    thousand: ',',
  },

  ko_KR: {
    currency: 'KRW',
    decimal: '.',
    symbol: '\u20A9',
    thousand: ',',
  },

  is_IS: {
    currency: 'ISK',
    decimal: ',',
    format: '%v %s',
    symbol: 'kr',
    thousand: '.',
  },
};

export default formats;
